/**
 * Troca do apelido de alguém dentro do servidor.
 *
 * Fica separado do menu porque o menu de contexto some no instante do clique, e
 * um modal que desmonta junto nunca chegaria a aparecer.
 *
 * Deixar o campo vazio devolve o nome de exibição original. É o caminho de
 * volta que a pessoa procura quando o apelido deixou de fazer sentido, e sem
 * ele só restaria digitar o nome antigo na mão.
 */

import { LIMITS, type GuildMember } from '@nexus/shared'
import { api } from '@/lib/api'
import { useAppStore } from '@/store/app'
import { NamePrompt } from '@/components/ui/dialogs'

export function NicknamePrompt({
  membro,
  guildId,
  onClose,
}: {
  membro: GuildMember | null
  guildId: string
  onClose: () => void
}) {
  const applyEvent = useAppStore((s) => s.applyEvent)

  return (
    <NamePrompt
      open={membro !== null}
      title="Alterar apelido"
      label={`Apelido de ${membro?.user.displayName ?? ''}`}
      initialValue={membro?.nickname ?? ''}
      placeholder={membro?.user.displayName}
      hint="O apelido vale só neste servidor."
      maxLength={LIMITS.displayName.max}
      permitirVazio
      onConfirm={async (valor) => {
        if (!membro) return
        const atualizado = await api.guilds.updateMember(guildId, membro.userId, {
          nickname: valor.length > 0 ? valor : null,
        })
        applyEvent({ op: 'member_update', d: atualizado, s: 0 })
      }}
      onClose={onClose}
    />
  )
}
